import { Injectable }               from '@angular/core';
import { UiKitModalDialogComp } from './uikit/uikit.modal.dialog';




@Injectable({ providedIn : 'root'})
export class UiKitModalDialogService {

	private _messageBox: UiKitModalDialogComp;
	set modalDialog( box: UiKitModalDialogComp){
		this._messageBox = box;
	}
	
	get modalDialog():UiKitModalDialogComp{
		return this._messageBox;
	}

	showInfoDialog( title:string , message:string  , owner:any , callback:any ){
		//console.info( "showInfoDialog( title:string , message:string ) "+ this._messageBox._displayModal);
		this._messageBox.dialogHeader  = title;
		this._messageBox.dialogContent = message;
		this._messageBox.dialogContentHtml = null;
		this._messageBox.displayModal = true;
		this._messageBox.ownerRef = owner;
		this._messageBox.callback = callback;
	}

	showInfoHtmlDialog( title:string , message:string  , owner:any , callback:any ){
		//console.info( "showInfoDialog( title:string , message:string ) "+ this._messageBox._displayModal);
		this._messageBox.dialogHeader  = title;
		this._messageBox.dialogContent = null;
		this._messageBox.dialogContentHtml = message;
		this._messageBox.displayModal = true;
		this._messageBox.ownerRef = owner;
		this._messageBox.callback = callback;
	}

	showWarnDialog( title:string , message:string  , owner:any , callback:any ){
		//console.info( "showInfoDialog( title:string , message:string ) "+ this._messageBox._displayModal);
		this._messageBox.dialogHeader  = title;
		this._messageBox.dialogContent = message;
		this._messageBox.dialogContentHtml = null;
		this._messageBox.displayModal = true;
		this._messageBox.ownerRef = owner;
		this._messageBox.callback = callback;
	}

	showSevereDialog( title:string , message:string  , owner:any , callback:any ){
		//console.info( "showInfoDialog( title:string , message:string ) "+ this._messageBox._displayModal);
		this._messageBox.dialogHeader  = title;
		this._messageBox.dialogContent = message;
		this._messageBox.dialogContentHtml = null;
		this._messageBox.displayModal = true;
		this._messageBox.ownerRef = owner;
		this._messageBox.callback = callback;
	}

	showConfirmationDialog( title:string , message:string  , owner:any , callback:any ){
		//console.info( "showInfoDialog( title:string , message:string ) "+ this._messageBox._displayModal);
		this._messageBox.dialogHeader  = title;
		this._messageBox.dialogContent = message;
		this._messageBox.dialogContentHtml = null;
		this._messageBox.displayModal = true;
		this._messageBox.button2 = "Cancel";
		this._messageBox.ownerRef = owner;
		this._messageBox.callback = callback;
	}
}
